var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_banner_box"},[_c('div',{staticClass:"container"},[_c('main-banner-carousel'),_c('main-banner-star')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }